

<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="6">
          <b-form-group label="From" label-cols-sm="4" label-cols-lg="3">
            <v-date-picker :formats='dateformats' v-model="fromDate" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>

        </b-col>
        <b-col lg="6">
          <b-form-group label="To" label-cols-sm="4" label-cols-lg="3">
            <v-date-picker :formats='dateformats' v-model="toDate" :input-props='{ class: "form-control" }' show-caps>
            </v-date-picker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-button variant="primary" class="pull-right" @click="search" :disabled="fromDate > toDate">
            Search
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>

<b-card>
  <v-client-table :columns="columns" :data="visitors" :options="options" :theme="theme" id="dataTable" ref="dataTable">
      <template slot="actions" slot-scope="data">
      <b-button size="sm" variant="primary" @click="showBooking(data.row)" class="mr-1"><i class="fa fa-pencil"></i></b-button>
    </template>
  </v-client-table>
</b-card>

<div>
  <b-modal ref="modalBooking" title="Allocate Room" hide-footer @hide="hideBooking" no-enforce-focus>
    <manual-room-allocate-edit v-if="selectedBooking" :booking="selectedBooking"  @success="editBookingSuccess" @cancel="cancelEditBooking" />
  </b-modal>
</div>
</div>

</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import ManualRoomAllocateEdit from './ManualRoomAllocateEdit'

export default {
  name: 'ManualRoomAllocateList',
  components: {
    ManualRoomAllocateEdit
  },
  data: function() {
    return {
      selectedBooking: null,
      columns: ['building.name', 'applicant_name', 'arrival_date', 'departure_date', 'actions'],
      options: {
        headings: {
          'building.name': 'Building Name',
          applicant_name: 'Satsangi Name',
          arrival_date: 'Arrival Date',
          departure_date : 'Departure Date'
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      theme: 'bootstrap4',

      fromDate: new Date(),
      toDate: new Date(),
      visitors: [],

      useVuex: false,

      building: {},

    }
  },
  methods: {
  hideBooking() {
    this.selectedBooking = null
    this.$refs.modalBooking.hide()
  },
  editBookingSuccess() {
    this.$refs.modalBooking.hide()
    this.search()
  },

  cancelEditBooking() {
    this.selectedBooking = null
    this.$refs.modalBooking.hide()
  },
  showBooking(booking) {
    console.log(booking);
    this.selectedBooking = booking
    this.$refs.modalBooking.show()
  },
  search() {
      this.visitors = []
      let params = {
        from: this.formatDate(this.fromDate),
        to: this.formatDate(this.toDate)
      }
      Vue.axios.get('admin/reports/visitors-allocation-by-range', {params: params})
      .then(response => {
        this.visitors = response.data.data
        this.showSuccessMsg()
      })
      .catch ( error => {
        this.showErrorMsg()
      });
    },

  },
  created () {
      Vue.axios.get("/buildings", null)
      .then(response => {this.building = response.data.data;})
      .catch ( error => { this.showErrorMsg()});
  },

}
</script>
